import { Loading, useTranslation } from "@opendash/core";
import { useNavigate, useParams } from "@opendash/router";
import { createComponent } from "@opendash/state";
import React from "react";
import { AppState } from "./App.state";

import { KnowledgeContent } from "./KnowledgeContent";
import { KnowledgeLayout } from "./KnowledgeLayout";

export const App = createComponent(function App() {
  const t = useTranslation();
  const state = React.useMemo(() => new AppState(), []);
  const navigate = useNavigate();
  const params = useParams();

  React.useEffect(() => {
    state.setParams(params);
  }, [params]);

  if (state.loading) {
    return <Loading message={t("opendash:ui.loading")} />;
  }

  return (
    <KnowledgeLayout state={state}>
      <KnowledgeContent state={state} />
    </KnowledgeLayout>
  );
});
